import { Box } from "@mui/material";
import BackButton from "../../../UIElements/BackButton";
import "../dossier-styles.scss";
import CustomProfil from "../../../Common/CustomProfil/CustomProfil";

type HeaderNavBarProps = {
    back: Function;
};

export default function HeaderNavBar({ back }: HeaderNavBarProps) {
    return (
        <Box>
            <BackButton back={back} />
            <CustomProfil />
        </Box>
    );
}
